export const SOCIAL_NETWORK = {
  GOOGLE: 'google',
  TWITTER: 'twitter',
  APPLE: 'apple',
};
export default {
  SOCIAL_NETWORK,
};
